// Mira lightweight telemetry — captures console logs, errors, navigations,
// and recent click breadcrumbs. Kept tiny so it never impacts UX.

const MAX_LOGS = 200;
const MAX_BREADCRUMBS = 30;
const logs = [];
const breadcrumbs = [];

function pushLog(level, args) {
  try {
    const msg = args.map((a) => {
      if (a instanceof Error) return `${a.name}: ${a.message}`;
      if (typeof a === "object") {
        try { return JSON.stringify(a); } catch { return String(a); }
      }
      return String(a);
    }).join(" ");
    logs.push({ ts: Date.now(), level, msg: msg.slice(0, 1000) });
    if (logs.length > MAX_LOGS) logs.shift();
  } catch { /* swallow */ }
}

function describeTarget(el) {
  if (!el || el === document) return "document";
  const tag = el.tagName ? el.tagName.toLowerCase() : "?";
  const tid = el.getAttribute?.("data-testid");
  if (tid) return `${tag}[data-testid="${tid}"]`;
  const id = el.id ? `#${el.id}` : "";
  const cls = el.className && typeof el.className === "string" ? `.${el.className.split(" ").slice(0, 2).join(".")}` : "";
  const text = (el.innerText || "").trim().slice(0, 40);
  return `${tag}${id}${cls}${text ? ` "${text}"` : ""}`;
}

let installed = false;
export function installMiraTelemetry() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  ["log", "info", "warn", "error", "debug"].forEach((level) => {
    const orig = console[level];
    console[level] = function (...args) {
      pushLog(level, args);
      return orig.apply(this, args);
    };
  });

  window.addEventListener("error", (e) => {
    pushLog("uncaught", [e?.message || "error", e?.filename, e?.lineno]);
  });
  window.addEventListener("unhandledrejection", (e) => {
    pushLog("unhandledrejection", [e?.reason?.message || String(e?.reason)]);
  });

  document.addEventListener(
    "click",
    (e) => {
      const target = e.target?.closest?.("button, a, [role='button'], [data-testid]") || e.target;
      breadcrumbs.push({ ts: Date.now(), kind: "click", target: describeTarget(target) });
      if (breadcrumbs.length > MAX_BREADCRUMBS) breadcrumbs.shift();
    },
    true,
  );

  let lastPath = window.location.pathname + window.location.hash;
  setInterval(() => {
    const now = window.location.pathname + window.location.hash;
    if (now !== lastPath) {
      breadcrumbs.push({ ts: Date.now(), kind: "navigate", to: now });
      if (breadcrumbs.length > MAX_BREADCRUMBS) breadcrumbs.shift();
      lastPath = now;
    }
  }, 750);
}

export function getMiraLogs() {
  return logs.slice(-MAX_LOGS);
}

export function getMiraTelemetry() {
  return {
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    platform: typeof navigator !== "undefined" ? navigator.platform : "",
    language: typeof navigator !== "undefined" ? navigator.language : "",
    viewport: typeof window !== "undefined" ? { w: window.innerWidth, h: window.innerHeight } : null,
    url: typeof window !== "undefined" ? window.location.href : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
    timestamp: new Date().toISOString(),
    breadcrumbs: breadcrumbs.slice(-MAX_BREADCRUMBS),
  };
}
